// @flow

import React from "react";

import LoginRequired from "../lib/LoginRequired";
import BaseSyncObjectForm from "../lib/BaseSyncObjectForm";
import type { UserProfile } from "../types/user_profile";

type Props = {
  setTitle: string => void,
  showBackButton: () => void,
  hideBackButton: () => void,
  user: UserProfile,
  match: {
    params: {
      object_name: string
    }
  }
};

class EditSyncObjectsView extends React.Component<Props> {
  componentWillMount = async () => {
    this.props.showBackButton();
    this.props.setTitle(`Editing ${this.props.match.params.object_name}`);
  };

  render = () => {
    return (
      <BaseSyncObjectForm
        {...this.props}
        objectName={this.props.match.params.object_name}
      />
    );
  };
}
export default LoginRequired(EditSyncObjectsView);



// WEBPACK FOOTER //
// ./src/views/EditSyncObjectsView.js